import { useEffect, useRef, useState } from 'react';
import isBrowser from '../services/isBrowser';
import { weatherSearchFormInit } from '../store/weatherSearchSlice';
import { useAppDispatch } from './useAppDispatch';
import { useElementSize } from './useElementSize';

export const useDelayedWeatherSearchForm = ({ scrollOffset, minWidth }: { scrollOffset: number, minWidth?: number }): string => {
    const idRef = useRef<string>(Math.random().toString(16));
    const [hasDispatched, setHasDispatched] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const width = useElementSize({});
    const checkScroll = () => {

        const scrollTop = window.scrollY;
        if (scrollTop > scrollOffset) {
            setHasDispatched(true);
            dispatch(weatherSearchFormInit(false, idRef.current));
        }
    }
    useEffect(() => {
        if (!isBrowser() || !width || hasDispatched) return;
        if (minWidth && width < minWidth) return;
        checkScroll();
        const onScroll = () => {
            checkScroll();
        };
        window.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
        }
    });

    return idRef.current;
}